<body>
  <div class="main-container d-flex flex-column">
    <app-login-header></app-login-header>

    <div class="container-fluid p-0 flex-grow-1">
      <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>
  </div>
</body>
